export const baseIconUrl = process.env.BUILD_DEPLOY_ENV === 'integration' ? process.env.REACT_APP_S3_BUILD_URL : ''
